import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import ExhibitorEventForm from "components/exhibitorEvents/ExhibitorEventForm";
import Alert from "components/common/Alert";
import {
  fetchExhibitorEventById,
  updateExhibitorEvent,
} from "api/exhibitorEvent.api";

export default function EditExhibitorEvent() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [initialData, setInitialData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [alert, setAlert] = useState(null);

  const userId = "69579c6190a653b640e65639";

  useEffect(() => {
    fetchExhibitorEventById(id)
      .then((res) => setInitialData(res.data?.data))
      .finally(() => setLoading(false));
  }, [id]);

  if (loading) return <p className="p-6">Loading...</p>;

  return (
    <>
      {alert && (
        <Alert
          type={alert.type}
          message={alert.message}
          onClose={() => setAlert(null)}
        />
      )}

      <ExhibitorEventForm
        initialData={initialData}
        onSubmit={async (payload) => {
          try {
            if (payload instanceof FormData) {
              payload.append("updated_by", userId);
            } else {
              payload.updated_by = userId;
            }

            await updateExhibitorEvent(id, payload);
            navigate("/admin/exhibitor-events");
          } catch (error) {
            setAlert({
              type: "error",
              message:
                error.response?.data?.message ||
                "Failed to update exhibitor event",
            });
          }
        }}
        onBack={() => navigate("/admin/exhibitor-events")}
      />
    </>
  );
}
